"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.status.enabled': 'Abilitato',
    'settings.status.disabled': 'Disabilitato',
    'settings.status.connected': 'Connesso',
    'settings.status.notConnected': 'Non Connesso',
    'settings.status.authenticated': 'Autenticato',
    'settings.status.notAuthenticated': 'Non Autenticato',
};
